import { makeStyles } from 'tss-react/mui';

const useStylesSearchDropdown: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  containerNoResults: {
    padding: '5px 20px',
    color: `${theme.palette.primary.main} !important`,
  },
  fieldTextSearch: {
    width: 'calc(100% - 24px) !important',
    margin: '5px 10px !important',
  },
  searchDropdownIcon: {
    color: theme.palette.info.main,
    marginTop: -2,
    marginRight: 5,
  },
}));

export default useStylesSearchDropdown;
